import { isEmpty, some, get } from 'lodash';
import { FlowNode, FilterCriteria } from '../flowState';

export const filterCannotContinue = (node: FlowNode) => {
  const filterCriteria = get(node, ['params', 'filter_criteria'], []) as Array<
    FilterCriteria
  >;
  // if there are any items that are valid, it can continue / should return false
  return isEmpty(filterCriteria)
    ? true
    : some(filterCriteria, criteria => {
        return !criteria.key || !criteria.match;
      });
};

export default filterCannotContinue;
